import React from 'react'

function PrivacyPolicy() {


    return (
        <>

            <div className="row col-10 offset-1 py-5 d-flex justify-content-around">
                <h3 className='text-center py-5'>About Us</h3>
            </div>
            <div className='row'>
                <div className="row col-5 py-5 mx-3 d-flex justify-content-left">
                    <h5>

                        <p><p className="fw-bold">Usha Rani Katakamsetty,</p>is
                            an ex-NIIT faculty, expert in C and C++, with a passion to teach, trained hundreds of Engineering students along with others during the past several years in Vijayawada and Hyderabad</p>

                    </h5>
                </div>
                <div className="row col-6 py-5 mx-3 d-flex justify-content-left">
                    <h5>

                        <p><p className="fw-bold">Raja Sekhar Katakamsetty,</p> is a freelance full stack developer with six years of experience
                            in designing, developing and deploying full stack web applications using Rails and React. You can view his profile on LinkedIn link give below.  </p>
                        <p>https://www.linkedin.com/in/rajkatakamsetty/</p>

                    </h5>
                </div>
            </div>

            <p className='text-center py-5'>* * *</p>

        </>
    )
}

export default PrivacyPolicy